import { activityApi } from "../api/activity";
import { nextPanelActivityStep } from "./activityIdentity";

// Sólo categorías cerradas. Nunca registrar montos, tarjetas, correos, nombres ni respuestas libres.
const ACTIONS = new Set([
  "billing_guide_opened", "billing_guide_step_viewed", "billing_guide_starter_previewed",
  "billing_guide_selection_saved", "billing_guide_draft_failed",
  "billing_guide_module_toggled", "billing_guide_selection_applied", "billing_guide_closed",
  "billing_conversion_cta_clicked", "billing_checkout_intent", "billing_checkout_failed",
]);
const SOURCES = new Set(["trial_banner", "trial_coach", "subscription_overview", "subscription_modules", "subscription_guide"]);
const STEPS = new Set(["entender", "elegir", "continuar"]);
const STATES = new Set(["trial_active", "trial_expired", "past_due_grace", "payment_restricted", "active"]);

export function trackBillingJourney(project, action, { source = "subscription_guide", step = "", state = "", moduleCode = "", actionKind = "" } = {}) {
  if (!ACTIONS.has(action) || !project) return;
  const projectSlug = String(project.slug || "");
  const projectId = String(project.id || project._id || "");
  if (!projectSlug && !projectId) return;
  const identity = nextPanelActivityStep();
  const path = `/dashboard/proyectos/${projectSlug || projectId}/configuracion/suscripcion`;
  activityApi.trackPanel({
    action,
    projectId,
    projectSlug,
    path,
    sessionId: identity.sessionId,
    tabId: identity.tabId,
    step: identity.step,
    journey: { channel: "panel", sessionId: identity.sessionId, tabId: identity.tabId, step: identity.step, path },
    metadata: {
      analyticsOnly: true,
      commercialJourneyVersion: 1,
      source: SOURCES.has(source) ? source : "subscription_guide",
      ...(STEPS.has(step) ? { guideStep: step } : {}),
      ...(STATES.has(state) ? { billingState: state } : {}),
      // Identificador de módulo únicamente; jamás valores de formulario ni precios.
      ...(moduleCode && /^[a-z_]{1,32}$/.test(moduleCode) ? { moduleCode } : {}),
      ...(actionKind && /^[a-z_]{1,32}$/.test(actionKind) ? { actionKind } : {}),
    },
  }).catch(() => null);
}
